export default __webpack_public_path__ + "BoxFlagLine.svg?f4707f4da58ce75023d5518ce905d691";